const token = localStorage.getItem("token");

export const fetchRequestOptions = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
};
